import React from "react";

const AdventurePlatformer = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <iframe
        src="/adventurePlatformer/index.html"
        width="2000"
        height="1280"
        style={{ border: "none" }}
        title="Game"
      />
    </div>
  );
};
  
export default AdventurePlatformer;